/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerCodeResponse } from '../models/customer-code-response';
import { CustomerFieldHistoryResponse } from '../models/customer-field-history-response';
import { CustomerResponse } from '../models/customer-response';
import { deleteApiCustomerV1Id } from '../fn/customer/delete-api-customer-v-1-id';
import { DeleteApiCustomerV1Id$Params } from '../fn/customer/delete-api-customer-v-1-id';
import { GenerateIbanCinResponse } from '../models/generate-iban-cin-response';
import { getApiCustomerV1Id$Json } from '../fn/customer/get-api-customer-v-1-id-json';
import { GetApiCustomerV1Id$Json$Params } from '../fn/customer/get-api-customer-v-1-id-json';
import { getApiCustomerV1Id$Plain } from '../fn/customer/get-api-customer-v-1-id-plain';
import { GetApiCustomerV1Id$Plain$Params } from '../fn/customer/get-api-customer-v-1-id-plain';
import { GetCustomersResponse } from '../models/get-customers-response';
import { patchApiCustomerV1Id$Json } from '../fn/customer/patch-api-customer-v-1-id-json';
import { PatchApiCustomerV1Id$Json$Params } from '../fn/customer/patch-api-customer-v-1-id-json';
import { patchApiCustomerV1Id$Plain } from '../fn/customer/patch-api-customer-v-1-id-plain';
import { PatchApiCustomerV1Id$Plain$Params } from '../fn/customer/patch-api-customer-v-1-id-plain';
import { postApiCustomerV1$Json } from '../fn/customer/post-api-customer-v-1-json';
import { PostApiCustomerV1$Json$Params } from '../fn/customer/post-api-customer-v-1-json';
import { postApiCustomerV1$Plain } from '../fn/customer/post-api-customer-v-1-plain';
import { PostApiCustomerV1$Plain$Params } from '../fn/customer/post-api-customer-v-1-plain';
import { postApiCustomerV1Create$Json } from '../fn/customer/post-api-customer-v-1-create-json';
import { PostApiCustomerV1Create$Json$Params } from '../fn/customer/post-api-customer-v-1-create-json';
import { postApiCustomerV1Create$Plain } from '../fn/customer/post-api-customer-v-1-create-plain';
import { PostApiCustomerV1Create$Plain$Params } from '../fn/customer/post-api-customer-v-1-create-plain';
import { postApiCustomerV1Export$Json } from '../fn/customer/post-api-customer-v-1-export-json';
import { PostApiCustomerV1Export$Json$Params } from '../fn/customer/post-api-customer-v-1-export-json';
import { postApiCustomerV1Export$Plain } from '../fn/customer/post-api-customer-v-1-export-plain';
import { PostApiCustomerV1Export$Plain$Params } from '../fn/customer/post-api-customer-v-1-export-plain';
import { postApiCustomerV1GenerateCode$Json } from '../fn/customer/post-api-customer-v-1-generate-code-json';
import { PostApiCustomerV1GenerateCode$Json$Params } from '../fn/customer/post-api-customer-v-1-generate-code-json';
import { postApiCustomerV1GenerateCode$Plain } from '../fn/customer/post-api-customer-v-1-generate-code-plain';
import { PostApiCustomerV1GenerateCode$Plain$Params } from '../fn/customer/post-api-customer-v-1-generate-code-plain';
import { postApiCustomerV1GenerateIbanCin$Json } from '../fn/customer/post-api-customer-v-1-generate-iban-cin-json';
import { PostApiCustomerV1GenerateIbanCin$Json$Params } from '../fn/customer/post-api-customer-v-1-generate-iban-cin-json';
import { postApiCustomerV1GenerateIbanCin$Plain } from '../fn/customer/post-api-customer-v-1-generate-iban-cin-plain';
import { PostApiCustomerV1GenerateIbanCin$Plain$Params } from '../fn/customer/post-api-customer-v-1-generate-iban-cin-plain';
import { postApiCustomerV1IdHistory$Json } from '../fn/customer/post-api-customer-v-1-id-history-json';
import { PostApiCustomerV1IdHistory$Json$Params } from '../fn/customer/post-api-customer-v-1-id-history-json';
import { postApiCustomerV1IdHistory$Plain } from '../fn/customer/post-api-customer-v-1-id-history-plain';
import { PostApiCustomerV1IdHistory$Plain$Params } from '../fn/customer/post-api-customer-v-1-id-history-plain';
import { postApiCustomerV1IdHistoryExport$Json } from '../fn/customer/post-api-customer-v-1-id-history-export-json';
import { PostApiCustomerV1IdHistoryExport$Json$Params } from '../fn/customer/post-api-customer-v-1-id-history-export-json';
import { postApiCustomerV1IdHistoryExport$Plain } from '../fn/customer/post-api-customer-v-1-id-history-export-plain';
import { PostApiCustomerV1IdHistoryExport$Plain$Params } from '../fn/customer/post-api-customer-v-1-id-history-export-plain';
import { postApiCustomerV1IdLock } from '../fn/customer/post-api-customer-v-1-id-lock';
import { PostApiCustomerV1IdLock$Params } from '../fn/customer/post-api-customer-v-1-id-lock';
import { postApiCustomerV1IdUnlock } from '../fn/customer/post-api-customer-v-1-id-unlock';
import { PostApiCustomerV1IdUnlock$Params } from '../fn/customer/post-api-customer-v-1-id-unlock';
import { postApiCustomerV1ReplaceBank$Json } from '../fn/customer/post-api-customer-v-1-replace-bank-json';
import { PostApiCustomerV1ReplaceBank$Json$Params } from '../fn/customer/post-api-customer-v-1-replace-bank-json';
import { postApiCustomerV1ReplaceBank$Plain } from '../fn/customer/post-api-customer-v-1-replace-bank-plain';
import { PostApiCustomerV1ReplaceBank$Plain$Params } from '../fn/customer/post-api-customer-v-1-replace-bank-plain';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiCustomerV1()` */
  static readonly PostApiCustomerV1Path = '/private/v1/customers';

  /**
   * Retrieves the list of all available  customers.
   *
   * Retrieves the list of all available  customers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1$Plain$Response(params?: PostApiCustomerV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCustomersResponse>> {
    return postApiCustomerV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  customers.
   *
   * Retrieves the list of all available  customers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1$Plain(params?: PostApiCustomerV1$Plain$Params, context?: HttpContext): Observable<GetCustomersResponse> {
    return this.postApiCustomerV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCustomersResponse>): GetCustomersResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all available  customers.
   *
   * Retrieves the list of all available  customers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1$Json$Response(params?: PostApiCustomerV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCustomersResponse>> {
    return postApiCustomerV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  customers.
   *
   * Retrieves the list of all available  customers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1$Json(params?: PostApiCustomerV1$Json$Params, context?: HttpContext): Observable<GetCustomersResponse> {
    return this.postApiCustomerV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCustomersResponse>): GetCustomersResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1Create()` */
  static readonly PostApiCustomerV1CreatePath = '/private/v1/customers/create';

  /**
   * Creates a new customer.
   *
   * Creates a new customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Create$Plain$Response(params?: PostApiCustomerV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return postApiCustomerV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new customer.
   *
   * Creates a new customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Create$Plain(params?: PostApiCustomerV1Create$Plain$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.postApiCustomerV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /**
   * Creates a new customer.
   *
   * Creates a new customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Create$Json$Response(params?: PostApiCustomerV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return postApiCustomerV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new customer.
   *
   * Creates a new customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Create$Json(params?: PostApiCustomerV1Create$Json$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.postApiCustomerV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1IdLock()` */
  static readonly PostApiCustomerV1IdLockPath = '/private/v1/customers/{id}/lock';

  /**
   * Lock customer by internal ID.
   *
   * Lock customer by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiCustomerV1IdLock$Response(params: PostApiCustomerV1IdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiCustomerV1IdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock customer by internal ID.
   *
   * Lock customer by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiCustomerV1IdLock(params: PostApiCustomerV1IdLock$Params, context?: HttpContext): Observable<void> {
    return this.postApiCustomerV1IdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1IdUnlock()` */
  static readonly PostApiCustomerV1IdUnlockPath = '/private/v1/customers/{id}/unlock';

  /**
   * Unlock customer by internal ID.
   *
   * Unlock customer by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiCustomerV1IdUnlock$Response(params: PostApiCustomerV1IdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiCustomerV1IdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock customer by internal ID.
   *
   * Unlock customer by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiCustomerV1IdUnlock(params: PostApiCustomerV1IdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postApiCustomerV1IdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getApiCustomerV1Id()` */
  static readonly GetApiCustomerV1IdPath = '/private/v1/customers/{id}';

  /**
   * Retrieves customer by id.
   *
   * Retrieves customer by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCustomerV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCustomerV1Id$Plain$Response(params: GetApiCustomerV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return getApiCustomerV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves customer by id.
   *
   * Retrieves customer by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCustomerV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCustomerV1Id$Plain(params: GetApiCustomerV1Id$Plain$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.getApiCustomerV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /**
   * Retrieves customer by id.
   *
   * Retrieves customer by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCustomerV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCustomerV1Id$Json$Response(params: GetApiCustomerV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return getApiCustomerV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves customer by id.
   *
   * Retrieves customer by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCustomerV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCustomerV1Id$Json(params: GetApiCustomerV1Id$Json$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.getApiCustomerV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiCustomerV1Id()` */
  static readonly DeleteApiCustomerV1IdPath = '/private/v1/customers/{id}';

  /**
   * deletes an existing customer.
   *
   * deletes an existing customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiCustomerV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCustomerV1Id$Response(params: DeleteApiCustomerV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiCustomerV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * deletes an existing customer.
   *
   * deletes an existing customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiCustomerV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCustomerV1Id(params: DeleteApiCustomerV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiCustomerV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchApiCustomerV1Id()` */
  static readonly PatchApiCustomerV1IdPath = '/private/v1/customers/{id}';

  /**
   * Partially updates an existing customer.
   *
   * Partially updates an existing customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiCustomerV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiCustomerV1Id$Plain$Response(params: PatchApiCustomerV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return patchApiCustomerV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing customer.
   *
   * Partially updates an existing customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiCustomerV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiCustomerV1Id$Plain(params: PatchApiCustomerV1Id$Plain$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.patchApiCustomerV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /**
   * Partially updates an existing customer.
   *
   * Partially updates an existing customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiCustomerV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiCustomerV1Id$Json$Response(params: PatchApiCustomerV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return patchApiCustomerV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing customer.
   *
   * Partially updates an existing customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiCustomerV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiCustomerV1Id$Json(params: PatchApiCustomerV1Id$Json$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.patchApiCustomerV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1GenerateCode()` */
  static readonly PostApiCustomerV1GenerateCodePath = '/private/v1/customers/generate-code';

  /**
   * Generates a customer code.
   *
   * Generates a customer code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1GenerateCode$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateCode$Plain$Response(params?: PostApiCustomerV1GenerateCode$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerCodeResponse>> {
    return postApiCustomerV1GenerateCode$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates a customer code.
   *
   * Generates a customer code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1GenerateCode$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateCode$Plain(params?: PostApiCustomerV1GenerateCode$Plain$Params, context?: HttpContext): Observable<CustomerCodeResponse> {
    return this.postApiCustomerV1GenerateCode$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerCodeResponse>): CustomerCodeResponse => r.body)
    );
  }

  /**
   * Generates a customer code.
   *
   * Generates a customer code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1GenerateCode$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateCode$Json$Response(params?: PostApiCustomerV1GenerateCode$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerCodeResponse>> {
    return postApiCustomerV1GenerateCode$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates a customer code.
   *
   * Generates a customer code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1GenerateCode$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateCode$Json(params?: PostApiCustomerV1GenerateCode$Json$Params, context?: HttpContext): Observable<CustomerCodeResponse> {
    return this.postApiCustomerV1GenerateCode$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerCodeResponse>): CustomerCodeResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1Export()` */
  static readonly PostApiCustomerV1ExportPath = '/private/v1/customers/export';

  /**
   * Export customers to CSV file report.
   *
   * Export customers to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1Export$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Export$Plain$Response(params?: PostApiCustomerV1Export$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1Export$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export customers to CSV file report.
   *
   * Export customers to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1Export$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Export$Plain(params?: PostApiCustomerV1Export$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1Export$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export customers to CSV file report.
   *
   * Export customers to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1Export$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Export$Json$Response(params?: PostApiCustomerV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1Export$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export customers to CSV file report.
   *
   * Export customers to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1Export$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1Export$Json(params?: PostApiCustomerV1Export$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1Export$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1ReplaceBank()` */
  static readonly PostApiCustomerV1ReplaceBankPath = '/private/v1/customers/replace-bank';

  /**
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1ReplaceBank$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1ReplaceBank$Plain$Response(params?: PostApiCustomerV1ReplaceBank$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1ReplaceBank$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1ReplaceBank$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1ReplaceBank$Plain(params?: PostApiCustomerV1ReplaceBank$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1ReplaceBank$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1ReplaceBank$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1ReplaceBank$Json$Response(params?: PostApiCustomerV1ReplaceBank$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1ReplaceBank$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * Replace the bank for all customers from an old bank to a new bank.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1ReplaceBank$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1ReplaceBank$Json(params?: PostApiCustomerV1ReplaceBank$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1ReplaceBank$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1IdHistory()` */
  static readonly PostApiCustomerV1IdHistoryPath = '/private/v1/customers/{id}/history';

  /**
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdHistory$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistory$Plain$Response(params: PostApiCustomerV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFieldHistoryResponse>> {
    return postApiCustomerV1IdHistory$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdHistory$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistory$Plain(params: PostApiCustomerV1IdHistory$Plain$Params, context?: HttpContext): Observable<CustomerFieldHistoryResponse> {
    return this.postApiCustomerV1IdHistory$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFieldHistoryResponse>): CustomerFieldHistoryResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdHistory$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistory$Json$Response(params: PostApiCustomerV1IdHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFieldHistoryResponse>> {
    return postApiCustomerV1IdHistory$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * Retrieves the list of all modification done to the customer with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdHistory$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistory$Json(params: PostApiCustomerV1IdHistory$Json$Params, context?: HttpContext): Observable<CustomerFieldHistoryResponse> {
    return this.postApiCustomerV1IdHistory$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFieldHistoryResponse>): CustomerFieldHistoryResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1GenerateIbanCin()` */
  static readonly PostApiCustomerV1GenerateIbanCinPath = '/private/v1/customers/generate-iban-cin';

  /**
   * Generates an IBAN and CIN for a customer.
   *
   * Generates an IBAN and CIN for a customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1GenerateIbanCin$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateIbanCin$Plain$Response(params?: PostApiCustomerV1GenerateIbanCin$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateIbanCinResponse>> {
    return postApiCustomerV1GenerateIbanCin$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates an IBAN and CIN for a customer.
   *
   * Generates an IBAN and CIN for a customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1GenerateIbanCin$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateIbanCin$Plain(params?: PostApiCustomerV1GenerateIbanCin$Plain$Params, context?: HttpContext): Observable<GenerateIbanCinResponse> {
    return this.postApiCustomerV1GenerateIbanCin$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenerateIbanCinResponse>): GenerateIbanCinResponse => r.body)
    );
  }

  /**
   * Generates an IBAN and CIN for a customer.
   *
   * Generates an IBAN and CIN for a customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1GenerateIbanCin$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateIbanCin$Json$Response(params?: PostApiCustomerV1GenerateIbanCin$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateIbanCinResponse>> {
    return postApiCustomerV1GenerateIbanCin$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates an IBAN and CIN for a customer.
   *
   * Generates an IBAN and CIN for a customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1GenerateIbanCin$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1GenerateIbanCin$Json(params?: PostApiCustomerV1GenerateIbanCin$Json$Params, context?: HttpContext): Observable<GenerateIbanCinResponse> {
    return this.postApiCustomerV1GenerateIbanCin$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenerateIbanCinResponse>): GenerateIbanCinResponse => r.body)
    );
  }

  /** Path part for operation `postApiCustomerV1IdHistoryExport()` */
  static readonly PostApiCustomerV1IdHistoryExportPath = '/private/v1/customers/{id}/history-export';

  /**
   * Export the list of all modification done to the customer with the provided ID.
   *
   * Export the list of all modification done to the customer with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdHistoryExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistoryExport$Plain$Response(params: PostApiCustomerV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1IdHistoryExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the customer with the provided ID.
   *
   * Export the list of all modification done to the customer with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdHistoryExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistoryExport$Plain(params: PostApiCustomerV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1IdHistoryExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export the list of all modification done to the customer with the provided ID.
   *
   * Export the list of all modification done to the customer with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCustomerV1IdHistoryExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistoryExport$Json$Response(params: PostApiCustomerV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiCustomerV1IdHistoryExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the customer with the provided ID.
   *
   * Export the list of all modification done to the customer with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCustomerV1IdHistoryExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCustomerV1IdHistoryExport$Json(params: PostApiCustomerV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiCustomerV1IdHistoryExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
